import { render, staticRenderFns } from "./ListaPacientes.vue?vue&type=template&id=525fff03&scoped=true&"
import script from "./ListaPacientes.vue?vue&type=script&lang=js&"
export * from "./ListaPacientes.vue?vue&type=script&lang=js&"
import style0 from "./ListaPacientes.vue?vue&type=style&index=0&id=525fff03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525fff03",
  null
  
)

export default component.exports